<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>课程配置</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-card shadow="hover">
            <!-- 搜索 -->
            <el-form :inline="true" size="small" v-model="listQuery">

                <el-form-item label="课程名称">
                    <el-input v-model="listQuery.courseName" placeholder="" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button icon="el-icon-search" type="primary" plan @click="querySearch">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" v-per="'addCourse'"  class="el-icon-plus" plan @click="addCourse">新增课程</el-button>
                     <el-button type="primary" v-per="'addCourse'"  class="el-icon-plus" plan @click="addCourseNew">新增课程(新版)</el-button>
                </el-form-item>

            </el-form>

            <!-- 列表数据 -->
            <el-table :data="listData" border style="width: 100%" class="table">
                <el-table-column type="index" label="序号" width="55"></el-table-column>
                <el-table-column prop="courseName" label="课程名称"></el-table-column>
                <el-table-column prop="courseType" label="课程分类">
                    <template slot-scope="scope">
                        <span style="">{{courseType[scope.row.courseType] }}</span>
                    </template>
                </el-table-column>

                    <el-table-column prop="isDocumentary" label="课程形式">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isDocumentary==1">线上</span>
                        <span  v-if="scope.row.isDocumentary==2">线下</span>
                        <span  v-if="scope.row.isDocumentary==3">线上和线下</span>
                    </template>
                </el-table-column>
                         <el-table-column prop="skillName" label="技能名称"></el-table-column>
                    <el-table-column prop="isDocumentary" label="课程内容">
                    <template slot-scope="scope">
                        <span v-if="scope.row.contentType==1">图文</span>
                        <span  v-if="scope.row.contentType==2">视频</span>
                    </template>
                </el-table-column>
                <el-table-column prop="isDocumentary" label="是否跟单">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isDocumentary==0">否</span>
                        <span style="color:blue;" v-if="scope.row.isDocumentary==1">无薪跟单</span>
                        <span style="color:green;" v-if="scope.row.isDocumentary==2">有薪跟单</span>
                    </template>
                </el-table-column>
              <el-table-column prop="isExam" label="是否需要考试">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isExam==0">否</span>
                        <span  v-if="scope.row.isExam==1">是</span>
                    </template>
                </el-table-column>
                            <el-table-column prop="isMust" label="是否必学">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isMust==0">否</span>
                        <span  v-if="scope.row.isMust==1">是</span>
                    </template>
                </el-table-column>
                    <el-table-column prop="isOpenClass" label="是否公开课">
                    <template slot-scope="scope">
                        <span v-if="scope.row.isOpenClass==0">否</span>
                        <span  v-if="scope.row.isOpenClass==1">是</span>
                    </template>
                </el-table-column>
                 <el-table-column prop="state" label="课程状态">
                    <template slot-scope="scope">
                        <span v-if="scope.row.state==0">开启</span>
                        <span  v-if="scope.row.state==1">关闭</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="课程背景图片" prop="picUrls">
        <template slot-scope="scope">
          <el-image  :src="scope.row.courseBackimg" :preview-src-list="[scope.row.courseBackimg]" :lazy="true" style="width: 60px; height: 60px; margin-right: 5px;" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="课程缩略图片" prop="picUrls">
        <template slot-scope="scope">
          <el-image  :src="scope.row.courseBackimgSamll" :preview-src-list="[scope.row.courseBackimgSamll]" :lazy="true" style="width: 60px; height: 60px; margin-right: 5px;" />
        </template>
      </el-table-column>
      <el-table-column align="center" label="视频列表" prop="picUrls" width="300">
        <template slot-scope="scope">
         <div v-for="(item,index) in scope.row.courseVideoList" :key="index" >
         <span>视频名称：{{item.videoName}}</span>
         </div>
        </template>
      </el-table-column>
                <el-table-column prop="createTime" :formatter="dateFormatA" label="创建时间"></el-table-column>

                <el-table-column label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <!-- <el-button type="text" v-per="'updateCourse'" icon="el-icon-edit" @click="handleEditStation( scope.row)">修改课程</el-button> -->
                         <el-button type="text" v-per="'delCourse'" icon="el-icon-delete" @click="handleDel(scope.$index, scope.row)">停用课程</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <!-- 分页 -->
            <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="querySearch" />
        </el-card>

        <el-dialog :title="addFrom.id?'修改课程':'添加课程'" :visible.sync="showAdd" width="400px" :close-on-click-modal="false" center>
            <el-form ref="addFrom"  :model="addFrom" :rules="addRules">
                <el-form-item label="课程名称" prop="courseName">
                    <el-input style="width:180px;" clearable v-model="addFrom.courseName"></el-input>
                </el-form-item>

                <el-form-item label="对应技能" prop="skillchoos">
                    <el-select v-model="addFrom.skillchoos" clearable multiple placeholder="请选择技能" filterable>
                        <el-option v-for="(item,index) in skillList" :key="index" :label="item.skillName" :value="item.id+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="课程类型" prop="courseType">
                    <el-select v-model="addFrom.courseType" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item,index) in courseType" :key="index" :label="item" :value="index+''"></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="是否跟单" prop="isDocumentary">
                    <el-select v-model="addFrom.isDocumentary" clearable placeholder="请选择" filterable>
                        <el-option v-for="(item,index) in isDocumentaryType" :key="index" :label="item" :value="index+''"></el-option>
                    </el-select>
                </el-form-item>
                

            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="showAdd = false">关闭</el-button>
                <el-button type="primary" @click="saveCourse('addFrom')">提交</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
import moment from "moment";
import Pagination from "@/components/common/Pagination";
import wmsApi from "@/script/api/wmsApi";
import service from "@/script/api/service";
import crmApi from "@/script/api/workercrmapi";
import globalData from "@/components/common/globaldata/global.data.vue";
let vm;
export default {
    components: { Pagination },
    data() {
        return {
            courseType: {
                0: "准入培训",
                1: "其他",
                2: "管理培训",
                3: "技能提升",
            },
            isDocumentaryType: {
                0: "否",
                1: "无薪跟单",
                2: "有薪跟单",
            },
            listData: [],

            skillList: [],
            total: 0,
            pageSize: 10,
            currentPage: 1, //当前页
            listQuery: {
                courseName: "",
            },
            
            addFrom: {
                skillchoos: [],

                courseName: null,
                courseType: null,
                skillId: null,
                // state: null,
                isDocumentary: null,
            },
            addRules: {
                courseName: [
                    {
                        required: true,
                        message: "请输入课程名称",
                        trigger: "blur",
                    },
                ],
                skillchoos: [
                    {
                        required: true,
                        message: "请选择技能",
                        trigger: "change",
                    },
                ],
                courseType: [
                    {
                        required: true,
                        message: "请选择课程类型",
                        trigger: "change",
                    },
                ],
                isDocumentary: [
                    {
                        required: true,
                        message: "请选择是否跟单",
                        trigger: "change",
                    },
                ],
            },
            showUpdate: false,
            showAdd: false,
        };
    },

    created() {
        // this.getAllPostStation();
        this.getAllSkill();

        this.querySearch();
    },
     activated(){
     this.querySearch();
  },
    methods: {
         handleDel(index, row) {
            this.$confirm("是否停用课程?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    crmApi
                        .$ajaxEmCourseDelCourse({
                            id: row.id,
                            updateUserId:globalData.userInfo.id
                        })
                        .then((res) => {
                            if (res.data.errno == 0) {
                                this.$message.success("操作成功");
                                this.querySearch();
                            }
                        });
                })
                .catch(() => {});
        },
        handleEditStation(row) {
            this.showAdd = true;
             this.addFrom = {
                id:row.id,
                skillchoos: row.skillId.split(','),
                courseName: row.courseName,
                courseType:  row.courseType+'',
                skillId: null, 
                isDocumentary: row.isDocumentary+'',
            }; 
        },
        addCourse() {
            this.showAdd = true;
            this.addFrom = {
                skillchoos: [],
                courseName: null,
                courseType: null,
                skillId: null, 
                isDocumentary: null,
            };
        },
         addCourseNew() {
             this.$router.push({
                path: "/workermanager/empowermentTrain/addCourse",
                query: {
                    // id: id,
                },

            });
        },
        
        saveCourse(formName) {
            this.$refs[formName].validate((valid) => {
               
                if (valid) {
                    this.addFrom.skillId = this.addFrom.skillchoos.join(",");
                    crmApi.$ajaxEmCourseAddCourse(this.addFrom).then((res) => {
                        if (res.data.errno == 0) {
                            this.$message.success("操作成功");
                            this.showAdd = false;
                            this.querySearch();
                        } else {
                            this.$message.error(res.data.data);
                        }
                    });
                }
            });
        },
      
        //查询
        querySearch() {
            this.listQuery.pageSize = this.pageSize;
            this.listQuery.pageNum = this.currentPage;
            crmApi.$ajaxEmCourseGetPageList(this.listQuery).then((res) => {
                if (res.data.errno == 0) {
                    this.listData = res.data.data.list;
                    this.total = res.data.data.total;
                }
            });
        },
        getAllSkill() {
            crmApi.$ajaxEmCourseGetAllSkillDict().then((res) => {
                if (res.data.errno == 0) {
                    this.skillList = res.data.data;
                }
            });
        },
    },
    beforeCreate() {
        vm = this;
    },
};
</script>
<style scoped>
.crumbs {
    margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
    margin: 10px 12px 0 0;
}
.el-image img {
    height: 60px;
    width: 60px;
    margin: 0 12px 12px 0;
    object-fit: cover;
}
</style>